import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HammerModule } from '@angular/platform-browser';
import { AppFacade } from '@floori-web/store';
import { CommonModule } from '@angular/common';
import { FlooriWebShellUiModule } from '@floori-web/shell/ui';
import { delayWhen, interval, of, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FLOORI_TRACKING_PROVIDER } from '@floori-web/constants';
import { FlooriTrackingProvider } from '@floori-web/tracking';
import { FlooriTrackingEventsList } from '@floori-web/models';
import { FLOORI_WINDOW, FlooriWindow } from '@floori-web-components';

@Component({
    imports: [CommonModule, RouterModule, HammerModule, FlooriWebShellUiModule],
    selector: 'floori-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
    private readonly appFacade = inject(AppFacade);
    private readonly tracking = inject<FlooriTrackingProvider>(FLOORI_TRACKING_PROVIDER);
    private readonly windowRef = inject<FlooriWindow>(FLOORI_WINDOW);
    readonly splash$ = this.appFacade.splash$.pipe(
        delayWhen(splash => (!splash?.visible ? interval(250) : of(undefined))),
    );
    readonly splashWithConfig$ = combineLatest([
        this.splash$,
        this.appFacade.companyConfig$
    ]).pipe(
        map(([splash, companyConfig]) => ({
            ...splash,
            flooriIoLinkEnable: companyConfig?.company?.flooriIoLinkEnable ?? false
        }))
    );
    readonly url = this.windowRef.location.href;

    ngOnInit(): void {
        this.tracking.track(FlooriTrackingEventsList.pageView);
    }
}
